<template>
  <div class="row mb-3">
    <h3 class="fw-bold mb-6">İstifadəçini dəyiş</h3>
    <div class="col-sm-12">
      <div class="card mb-3">
        <div class="card-header py-3 d-flex justify-content-between bg-transparent border-bottom-0">
          <h6 class="mb-0 fw-bold ">İstifadəçi</h6>
        </div>

        <!-- Form body -->
        <div class="card-body">
          <form @submit.prevent="updateUser">
            <!-- Input fields -->
            <div class="row g-3 align-items-center">
              <!-- Name -->
              <div class="col-md-6">
                <label for="firstName" class="form-label">partnerId</label>
                <input type="text" v-model="nitem.partnerId" v-validate="{ required: true, max: 25}" name="nameField" id="firstName" class="form-control" required="" disabled>
                <span class="inputError">{{ errors.first('nameField') }}</span>
              </div>

              <div class="col-md-6">
                <label for="firstName" class="form-label">smsFee</label>
                <input type="text" v-model.number="nitem.smsFee" v-validate="{ required: true, max: 25}" name="smsFee" id="firstName" class="form-control" required="">
                <span class="inputError">{{ errors.first('smsFee') }}</span>
              </div>

              <div class="col-md-6">
                <label for="firstName" class="form-label">smsBalance</label>
                <input type="text" v-model.number="nitem.smsBalance" v-validate="{ required: true, max: 25}" name="smsBalance" id="firstName" class="form-control" required="">
                <span class="inputError">{{ errors.first('smsBalance') }}</span>
              </div>

              <!-- SMS Notification -->
              <div class="col-md-6 d-flex flex-row">
                <div class="d-flex flex-column">
                  <label for="smsCheckbox" class="form-label">Aktiv</label>
                  <input type="checkbox" v-model="nitem.isActive" class="smsCheckbox" name="smsCheckbox" id="smsCheckbox">
                </div>
              </div>

              <div class="col-md-6 d-flex flex-row">
                <div class="d-flex flex-column">
                  <label for="smsCheckbox2" class="form-label">requiredSmsShablonConfirmation</label>
                  <input type="checkbox" v-model="nitem.requiredSmsShablonConfirmation" name="smsCheckbox2" class="smsCheckbox" id="smsCheckbox2">
                </div>
              </div>


            </div>

            <!-- Submit button -->
            <button type="submit" class="btn btn-primary mt-4" :disabled="loading">
              Yaddaşa yaz
            </button>
          </form>
        </div>
      </div>
    </div>

    <div class="col-sm-12">
      <div class="card mb-3">
        <div class="card-header py-3 d-flex justify-content-between bg-transparent border-bottom-0">
          <h6 class="mb-0 fw-bold ">Partnyor redakte</h6>
        </div>

        <!-- Form body -->
        <div class="card-body">
          <form @submit.prevent="updateUser2">
            <!-- Input fields -->
            <div class="row g-3 align-items-center">
              <div class="col-md-6">
                <label for="partnerId2" class="form-label">PartnerId</label>
                <input type="text" v-model="nitem2.partnerId" v-validate="{ required: true, max: 25}" name="smsFee" id="partnerId2" class="form-control" required="">
                <span class="inputError">{{ errors.first('partnerId2') }}</span>
              </div>

              <div class="col-md-6">
                <label for="listeningUrl" class="form-label">listeningUrl</label>
                <input type="text" v-model="nitem2.listeningUrl" name="listeningUrl" id="listeningUrl" class="form-control">
              </div>

              <div class="col-md-6">
                <label for="sendingUrl" class="form-label">sendingUrl</label>
                <input type="text" v-model="nitem2.sendingUrl" name="sendingUrl" id="sendingUrl" class="form-control">
              </div>

              <div class="col-md-6">
                <label for="operatorChannels1" class="form-label">operatorChannels: Azercell</label>
                <input type="text" v-model="nitem2.operatorChannels[1]" name="operatorChannels1" id="operatorChannels1" class="form-control">
              </div>

              <div class="col-md-6">
                <label for="operatorChannels2" class="form-label">operatorChannels: Bakcell</label>
                <input type="text" v-model="nitem2.operatorChannels[2]" name="operatorChannels2" id="operatorChannels2" class="form-control">
              </div>

              <div class="col-md-6">
                <label for="operatorChannels3" class="form-label">operatorChannels: Nar</label>
                <input type="text" v-model="nitem2.operatorChannels[3]" name="operatorChannels3" id="operatorChannels3" class="form-control">
              </div>

              <div class="col-md-6">
                <label for="shortNumberChannels.shortNumber" class="form-label">shortNumberChannels.shortNumber: Azercell</label>
                <input type="text" v-model="nitem2.shortNumberChannels[0].shortNumber" name="shortNumberChannels.shortNumber" id="shortNumberChannels.shortNumber" class="form-control">
              </div>

              <div class="col-md-6">
                <label for="shortNumberChannels.channel" class="form-label">shortNumberChannels.channel: Azercell</label>
                <input type="text" v-model="nitem2.shortNumberChannels[0].channel" name="shortNumberChannels.channel" class="form-control">
              </div>

              <div class="col-md-6">
                <label for="shortNumberChannels.shortNumber" class="form-label">shortNumberChannels.shortNumber: Bakcell</label>
                <input type="text" v-model="nitem2.shortNumberChannels[1].shortNumber" name="shortNumberChannels.shortNumber" id="shortNumberChannels.shortNumber" class="form-control">
              </div>

              <div class="col-md-6">
                <label for="shortNumberChannels.channel" class="form-label">shortNumberChannels.channel: Bakcell</label>
                <input type="text" v-model="nitem2.shortNumberChannels[1].channel" name="shortNumberChannels.channel" class="form-control">
              </div>

              <div class="col-md-6">
                <label for="shortNumberChannels.shortNumber" class="form-label">shortNumberChannels.shortNumber: Nar</label>
                <input type="text" v-model="nitem2.shortNumberChannels[2].shortNumber" name="shortNumberChannels.shortNumber" id="shortNumberChannels.shortNumber" class="form-control">
              </div>

              <div class="col-md-6">
                <label for="shortNumberChannels.channel" class="form-label">shortNumberChannels.channel: Nar</label>
                <input type="text" v-model="nitem2.shortNumberChannels[2].channel" name="shortNumberChannels.channel" class="form-control">
              </div>

              <div class="col-md-6">
                <label for="shortNumbers" class="form-label">shortNumbers: Azercell</label>
                <input type="text" v-model="shortNumbers[1]" name="shortNumbers"  class="form-control">
              </div>

              <div class="col-md-6">
                <label for="shortNumbers" class="form-label">shortNumbers: Bakcell</label>
                <input type="text" v-model="shortNumbers[2]" name="shortNumbers" class="form-control">
              </div>

              <div class="col-md-6">
                <label for="shortNumbers" class="form-label">shortNumbers: Nar</label>
                <input type="text" v-model="shortNumbers[3]" name="shortNumbers" class="form-control">
              </div>

              <div class="col-md-6">
                <label for="clientIps" class="form-label">clientIps</label>
                <textarea type="text" v-model="clientIps" name="clientIps" class="form-control" rows="5"></textarea>
              </div>
            </div>

            <!-- Submit button -->
            <button type="submit" class="btn btn-primary mt-4" :disabled="loading">
              Yaddaşa yaz
            </button>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import user from '../../../store/user'
import jwtInterceptor from '../../../jwt.interceptor'
import store from '../../../store'

export default {
  name: 'UserUpdate',
  data() {
    return {
      shortNumbers: {
          1: "",
          2: "",
          3: ""
        },
      clientIps: "",
      nitem: {},
      nitem2: {
        partnerId: "",
        operatorChannels: {
          1: "",
          2: "",
          3: ""
        },
        shortNumberChannels: [
          {
            mobileOperator: 1,
            shortNumber: "",
            channel: ""

          },
          {
            mobileOperator: 2,
            shortNumber: "",
            channel: ""

          },
          {
            mobileOperator: 3,
            shortNumber: "",
            channel: ""

          }
        ],
        listeningUrl: "",
        clientIps: [],
        shortNumbers: {
          1: "",
          2: "",
          3: ""
        },
        sendingUrl: "",
      },
      roles: [],
      loading: false,
    }
  },
  methods: {
    async updateUser() {

      const validForm = await this.isFormValid()
      if (validForm) {
        this.loading = true
        jwtInterceptor.put(this.$store.getters.getUrl + "/Users/"+this.nitem.id,{
          isActive: this.nitem.isActive ? true:false,
          requiredSmsShablonConfirmation: this.nitem.requiredSmsShablonConfirmation ? true:false,
          smsFee: this.nitem.smsFee,
          smsBalance: this.nitem.smsBalance
        }).then(response => {
          if (response.data.isError === null) {
            this.$toast.success("İstifadəçi uğurla dəyişildi!", {
              position: "top-right"
            })
            this.loading = false
            this.$router.go(-1);
          }
          else {
            this.$toast.error("Bir xəta baş verdi. Bir daha sınayın!", {
              position: "top-right"
            });
            this.loading = false
          }
        }).catch(() => {
          this.$toast.error("Bir xəta baş verdi!", {
            position: "top-right"
          });
          this.loading = false
        })
      } 
      else {
        this.$toast.error("Xanalar düzgün doldurulmayıb. Bir daha xanaları yoxlayın!", {
          position: "top-right"
        })
        this.loading = false
      }
    },
    async updateUser2() {

      this.nitem2.shortNumbers[1] =  this.shortNumbers[1].split(',')
      this.nitem2.shortNumbers[2] =  this.shortNumbers[2].split(',')
      this.nitem2.shortNumbers[3] =  this.shortNumbers[3].split(',')
      this.nitem2.clientIps =  this.clientIps.split(',').map(ip => ip.trim())
      const validForm = await this.isFormValid()
      if (validForm) {
        this.loading = true
        jwtInterceptor.put(this.$store.getters.getUrl + "/generalpartners/"+this.nitem2.partnerId,this.nitem2).then(response => {
          if (response.data.isError === null) {
            this.$toast.success("İstifadəçi uğurla dəyişildi!", {
              position: "top-right"
            })
            this.loading = false
            this.$router.go(-1);
          }
          else {
            this.$toast.error("Bir xəta baş verdi. Bir daha sınayın!", {
              position: "top-right"
            });
            this.loading = false
          }
        }).catch(() => {
          this.$toast.error("Bir xəta baş verdi!", {
            position: "top-right"
          });
          this.loading = false
        })
      } 
      else {
        this.$toast.error("Xanalar düzgün doldurulmayıb. Bir daha xanaları yoxlayın!", {
          position: "top-right"
        })
        this.loading = false
      }
    },
    isFormValid() {
      // eslint-disable-next-line vue/no-async-in-computed-properties, no-async-promise-executor
      return new Promise(async (resolve, reject) => {
        try {
          const valid = await this.$validator.validate();
          resolve(valid);
        } catch (error) {
          reject(error);
        }
      });
    },

  },
  created() {
    this.roles = user.state.roles;
    this.nitem = user.getters.getUserUpdate;

    this.nitem2.listeningUrl = this.nitem.listeningUrl;
    this.nitem2.partnerId = this.nitem.partnerId;
    this.nitem2.sendingUrl = this.nitem.sendingUrl;
    this.nitem2.operatorChannels = this.nitem.operatorChannels;
    this.nitem.shortNumberChannels.map((e) => {
      let foundIndex = this.nitem2.shortNumberChannels.findIndex(item => item.mobileOperator === e.mobileOperator);
      if (foundIndex !== -1) {
        this.nitem2.shortNumberChannels[foundIndex].shortNumber = e.shortNumber; // Update shortNumber
        this.nitem2.shortNumberChannels[foundIndex].channel = e.channel;       // Update channel
      }
    })
    this.nitem2.shortNumbers = this.nitem.shortNumbers;
    this.clientIps = this.nitem.clientIps.join(",");
    if(this.nitem.shortNumbers[1])
      this.shortNumbers[1] = this.nitem.shortNumbers[1].join(",") 
    if(this.nitem.shortNumbers[2])
      this.shortNumbers[2] = this.nitem.shortNumbers[2].join(",") 
    if(this.nitem.shortNumbers[3])
      this.shortNumbers[3] = this.nitem.shortNumbers[3].join(",") 

    this.nitem.isActive = this.nitem.isActive ? 1:0;
    this.nitem.requiredSmsShablonConfirmation = this.nitem.requiredSmsShablonConfirmation ? 1:0;
    
  }
}
</script>